import { render, staticRenderFns } from "./AccountantSettings.vue?vue&type=template&id=61204417&scoped=true"
import script from "./AccountantSettings.vue?vue&type=script&lang=ts"
export * from "./AccountantSettings.vue?vue&type=script&lang=ts"
import style0 from "./AccountantSettings.vue?vue&type=style&index=0&id=61204417&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61204417",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61204417')) {
      api.createRecord('61204417', component.options)
    } else {
      api.reload('61204417', component.options)
    }
    module.hot.accept("./AccountantSettings.vue?vue&type=template&id=61204417&scoped=true", function () {
      api.rerender('61204417', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountantSettings.vue"
export default component.exports